import _ from 'lodash';
import moment from 'moment';

const initialState = {
	homePageAssetsBackup: [],
	homePageAssets: {
		mainBanner: null,
		contentSlot: null,
		rotatingBanners: [],
	},
	assets: null,
	editAsset: null,
	assetsFilter: null,
	rebatesAndClaims: null,
	editRebateAsset: null,
	editPriceExports:null,
	message:null
};

export default function homepage(state = initialState, action) {
    switch (action.type) {
		case 'UPDATE_HOME_PAGE_ASSETS':
			return {
				...state,
				homePageAssets: action.data.homePageAssets,
				rotatingBanners: [],
			}
		case 'UPDATE_ROTATING_BANNERS':
			return {
				...state,
				rotatingBanners: {
					...state.rotatingBanners,
					[action.customerType]: action.data
				},
			}
		// case 'SAVE_HOME_PAGE_ASSETS':
		// 	const customerType = action.data && action.data.customerType;
		// 	action.data = action.data.responseObject?action.data.responseObject:action.data;
		// 	const contentSlot = [];
		// 	action.data.marketingSlots && action.data.marketingSlots.map((item, index) => {
		// 		var StartDate = _.find(item.attributes, ["name", "StartDate"]),
		// 			EndDate = _.find(item.attributes, ["name", "EndDate"]),
		// 			Priority = _.find(item.attributes, ["name", "Priority"]);
		// 		item.StartDate = (StartDate && StartDate.values && StartDate.values[0] && StartDate.values[0].value)?StartDate.values[0].value.trim():null;
		// 		item.EndDate = (EndDate && EndDate.values && EndDate.values[0] && EndDate.values[0].value)?EndDate.values[0].value.trim():null;
		// 		item.Priority = (Priority && Priority.values && Priority.values[0] && Priority.values[0].value)?Priority.values[0].value.trim():null;
		// 		contentSlot.push(item);
		// 		return null;
		// 	});
		// 	// const mainBanner = {
		// 	// 	...action.data.mainBanner,
		// 	// 	link: action.data.mainBanner && _.find(action.data.mainBanner.attributes, ["name", "Link"]).values[0].value,
		// 	// 	imageURL: action.data.mainBanner && _.find(action.data.mainBanner.attributes, ["name", "Image"]).values[0].value
		// 	// }

		// 	const rotatingBanners = [];
		// 	action.data.rotatingBanners && action.data.rotatingBanners.map((item, index) => {
		// 		var StartDate = _.find(item.attributes, ["name", "StartDate"]),
		// 			EndDate = _.find(item.attributes, ["name", "EndDate"]),
		// 			Priority = _.find(item.attributes, ["name", "Priority"]);
		// 		item.StartDate = (StartDate && StartDate.values && StartDate.values[0] && StartDate.values[0].value)?StartDate.values[0].value.trim():null;
		// 		item.EndDate = (EndDate && EndDate.values && EndDate.values[0] && EndDate.values[0].value)?EndDate.values[0].value.trim():null;
		// 		item.Priority = (Priority && Priority.values && Priority.values[0] && Priority.values[0].value)?Priority.values[0].value.trim():null;
		// 		rotatingBanners.push(item);
		// 		return null;
		// 	});
		// 	const homePageAssets = {
		// 		// mainBanner: action.data.mainBanner ? mainBanner : null,
		// 		contentSlot: _.sortBy(contentSlot, ["Priority"]),
		// 		rotatingBanners: _.sortBy(rotatingBanners, ["Priority"]),
		// 	};
		// 	const homePageAssetsBackup = state.homePageAssetsBackup;
		// 	homePageAssetsBackup.push({
		// 		customerType: customerType.toLowerCase(),
		// 		homePageAssets: JSON.parse(JSON.stringify(homePageAssets))
		// 	});
	    //     return {
	    //         ...state,
		// 		homePageAssetsBackup,
	    //         homePageAssets: JSON.parse(JSON.stringify(homePageAssets))
	    //     }
		case 'SAVE_ASSETS_FILTERS':
			return {
				...state,
				assetsFilter: action.data
			}
		case 'SAVE_ASSETS':
			return {
				...state,
				assets: action.data
			}
		case 'SAVE_MESSAGES':
			return {
				...state,
				message: action.data
			}
		case 'SAVE_EDIT_REBATES_AND_CLAIMS':
			return {
				...state,
				editRebateAsset: action.data
			}
		case 'SAVE_EDIT_PRICE_EXPORTS':
			return {
				...state,
				editPriceExports: action.data
			}
		case 'POPULATE_LATEST_HOMEPAGE_ASSETS':
			const today = moment();
			const retailRotatingBanners = state.assets ? state.assets.responseObject.filter(itm => itm.customerType === 'Retail' && itm.assetType === 'RotatingBanner' && !(today.isBefore(moment(itm.startDate)) || today.isAfter(moment(itm.endDate)))) : [];
			const contractRotatingBanners = state.assets ? state.assets.responseObject.filter(itm => itm.customerType === 'Contract' && itm.assetType === 'RotatingBanner' && !(today.isBefore(moment(itm.startDate)) || today.isAfter(moment(itm.endDate)))) : [];
			const proChannelRotatingBanners = state.assets ? state.assets.responseObject.filter(itm => itm.customerType === 'PRO CHANNEL' && itm.assetType === 'RotatingBanner' && !(today.isBefore(moment(itm.startDate)) || today.isAfter(moment(itm.endDate)))) : [];
			const partsRotatingBanners = state.assets ? state.assets.responseObject.filter(itm => itm.customerType === 'Parts' && itm.assetType === 'RotatingBanner' && !(today.isBefore(moment(itm.startDate)) || today.isAfter(moment(itm.endDate)))) : [];
			const retailContentSlot = state.assets ? state.assets.responseObject.filter(itm => itm.customerType === 'Retail' && itm.assetType === 'MarketingSlot' && !(today.isBefore(moment(itm.startDate)) || today.isAfter(moment(itm.endDate)))) : [];
			const contractContentSlot = state.assets ? state.assets.responseObject.filter(itm => itm.customerType === 'Contract' && itm.assetType === 'MarketingSlot' && !(today.isBefore(moment(itm.startDate)) || today.isAfter(moment(itm.endDate)))) : [];
			const proChannelContentSlot = state.assets ? state.assets.responseObject.filter(itm => itm.customerType === 'PRO CHANNEL' && itm.assetType === 'MarketingSlot' && !(today.isBefore(moment(itm.startDate)) || today.isAfter(moment(itm.endDate)))) : [];
			const partsContentSlot = state.assets ? state.assets.responseObject.filter(itm => itm.customerType === 'Parts' && itm.assetType === 'MarketingSlot' && !(today.isBefore(moment(itm.startDate)) || today.isAfter(moment(itm.endDate)))) : [];
			return {
				...state,
				rotatingBanners: {
					retail: _.sortBy(retailRotatingBanners, ["priority"]),
					contract: _.sortBy(contractRotatingBanners, ["priority"]),
					pro: _.sortBy(proChannelRotatingBanners, ["priority"]),
					parts: _.sortBy(partsRotatingBanners, ["priority"])
				},
				contentSlot: {
					retail: _.sortBy(retailContentSlot, ["priority"]),
					contract: _.sortBy(contractContentSlot, ["priority"]),
					pro: _.sortBy(proChannelContentSlot, ["priority"]),
					parts: _.sortBy(partsContentSlot, ["priority"])
				}
			}
		case 'SAVE_EDIT_ASSET':
			return {
				...state,
				editAsset: action.data
			}
		case 'SAVE_REBATES_AND_CLAIMS':
			return {
				...state,
				rebatesAndClaims: action.data
			}
		case 'RESET_HOMEPAGE_REDUCERS':
			return {
				...initialState,
				homePageAssetsBackup: [],
			};
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/homepage.js